import { Caption } from '@mediahuis/chameleon-react';

const SmallErrorMessage = ({ children }) => (
  <Caption color="colorRed40">{children}</Caption>
);

export default SmallErrorMessage;
